import { render, staticRenderFns } from "./AboutTheData.vue?vue&type=template&id=d1a7257a"
import script from "./AboutTheData.vue?vue&type=script&lang=js"
export * from "./AboutTheData.vue?vue&type=script&lang=js"
import style0 from "./AboutTheData.vue?vue&type=style&index=0&id=d1a7257a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports